import axios from "axios"
import { APPCONFIG } from "../app-config"

const axiosConfig = {
  baseURL: APPCONFIG.axiosBaseUrl
}

export default axios.create(axiosConfig)
